import { render } from "./EditAccountManager.vue?vue&type=template&id=08882b17"
import script from "./EditAccountManager.vue?vue&type=script&lang=js"
export * from "./EditAccountManager.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/hospitals/accountsManagers/EditAccountManager.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "08882b17"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('08882b17', __exports__)) {
    console.log('reload')
    api.reload('08882b17', __exports__)
  }
  
  module.hot.accept("./EditAccountManager.vue?vue&type=template&id=08882b17", () => {
    console.log('re-render')
    api.rerender('08882b17', render)
  })

}


export default __exports__